import PageShell, { PageIntro } from "@/components/PageShell";

const FAQS = [
    ["Who is my employer?", [
        "The recruitment company that advertised your role, arranged your interview, advised you that you were successful and negotiated your rate will generally be your employer under the PayMe model.",
        "Some recruitment companies describe themselves as a consultancy, recruitment agency or by another term. What they call themselves does not, by itself, determine the employment relationship.",
        "PayMe's role is different. We provide an outsourced payroll service and enter into an agreement with your recruitment company that allows us to process your payroll.",
        "PayMe will generally sign any contract, even though almost all of them describe us as the company that supplied you to your employer. If we did not sign them, we would not be in business. So we alert everyone to our concerns, then get on with having a good working relationship.",
    ], [["Fair Work Commission, labour hire workers", "https://www.fwc.gov.au/"], ["SafeWork NSW, labour hire", "https://www.safework.nsw.gov.au/"]]],
    ["When do I get paid?", [
        "Your pay cycle follows the arrangement you have with your recruitment company.",
        "PayMe invoices your recruitment company and, once payment is received, deducts the payroll fee you agreed to when you joined PayMe.",
        "We email you a draft payslip to review before your payment is processed and a final payslip once payment has been made. You can also download your payslips from the Contractor Portal at any time.",
    ]],
    ["What happens if my recruitment company pays late?", [
        "We follow up with your recruitment company and keep you informed. You will have a named contact at PayMe, so you know who to speak to if there is a problem.",
        "Under the PayMe General Terms and Conditions, PayMe is not liable to pay your net remuneration until the corresponding payment has been received from your recruitment company.",
    ]],
    ["What forms do I need to complete?", [
        "As part of joining PayMe, you authorise us to provide outsourced payroll services and to liaise with your employer to put the necessary payroll arrangements in place.",
        "You will also complete the standard payroll information we need, including: your Tax File Number declaration, your superannuation choice details and your bank account details.",
        "These are completed electronically through our payroll system once you receive your login details.",
    ]],
    ["How do I submit timesheets?", [
        "We don't use a one-size-fits-all approach.",
        "Depending on your recruitment company's requirements, timesheets can be submitted through the PayMe Contractor Portal, emailed to our timesheets inbox (timesheets@payme.com.au), or submitted through your recruitment company's own system.",
        "We'll tell you exactly which method applies during onboarding, so you don't have to manage an unnecessary second timesheet process.",
    ]],
    ["Can I join with a Pty Ltd or ABN?", [
        "No. PayMe's contractor payroll service is for workers employed through recruitment companies.",
        "We do not provide this service to Pty Ltd entities, workers operating through trusts or sole traders invoicing under an ABN.",
    ]],
    ["How much does PayMe cost?", ["Our standard payroll fee is 1.25% of the payment we receive from your recruitment company."]],
];

export default function Faqs() {
    return (
        <PageShell testId="faqs-page">
            <PageIntro eyebrow="Help" title="Frequently Asked Questions" />
            <div className="mx-auto max-w-7xl px-5 pb-20 md:px-8">
                <div className="max-w-3xl divide-y divide-border">
                    {FAQS.map(([q, paras, refs], i) => (
                        <details key={q} className="group py-5" open={i === 0} data-testid={`faq-${i}`}>
                            <summary className="cursor-pointer list-none font-display text-xl font-bold text-primary sm:text-2xl marker:content-none">{q}</summary>
                            <div className="mt-3 space-y-3 text-lg text-foreground/80">
                                {paras.map((p) => <p key={p}>{p}</p>)}
                                {refs && (
                                    <>
                                        <p>Useful references:</p>
                                        <ul className="list-disc space-y-1 pl-6">{refs.map(([t, h]) => <li key={h}><a href={h} target="_blank" rel="noopener noreferrer" className="font-semibold text-primary hover:underline">{t}</a></li>)}</ul>
                                    </>
                                )}
                            </div>
                        </details>
                    ))}
                </div>
            </div>
        </PageShell>
    );
}
